var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menu-item-wrapper no-highlight",
      class: _vm.styleWrapper(),
      attrs: { tabindex: "0", "aria-label": _vm.item.name, alt: _vm.item.name },
      on: {
        click: _vm.handleClickMenuItem,
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.handleClickMenuItem($event)
        }
      }
    },
    [
      _vm.displayInfo()
        ? _c(
            "div",
            {
              ref: "infoCard",
              staticClass: "info-wrapper",
              class: _vm.infoStyle()
            },
            [
              _c("div", { ref: "colorBar", staticClass: "item-color-bar" }),
              _vm._v(" "),
              _c("h2", { staticClass: "item-name truncate" }, [
                _vm._v(_vm._s(_vm.item.name))
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayQuickAdd()
        ? _c(
            "div",
            { staticClass: "quick-add-quantity" },
            [
              _c("BaseQuantityButtons", {
                attrs: {
                  customType: "quick-add-overlay",
                  quantity: _vm.itemQuantity
                },
                on: {
                  incrementQuantity: function($event) {
                    return _vm.increment()
                  },
                  decrementQuantity: function($event) {
                    return _vm.decrement()
                  },
                  setInputQuantity: _vm.setQuantityFromInput
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayQuickAdd()
        ? _c("div", { ref: "quickAdd", staticClass: "quick-add" }, [
            _c("div", [_vm._v("Add to cart")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("menu-item-image", { attrs: { item: _vm.item } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36169b4f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36169b4f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/MenuItem/MenuItem.vue
// module id = null
// module chunks = 